type ConflictDialogProps = {
  open: boolean;
  onAcceptServer(): void;
  onReapplyLocal(): void;
  onCopyLocal?(): void;
};

export function ConflictDialog({
  open,
  onAcceptServer,
  onReapplyLocal,
  onCopyLocal,
}: ConflictDialogProps) {
  if (!open) return null;
  return (
    <div className="dialog-backdrop" role="presentation">
      <section className="dialog" role="dialog" aria-modal="true" aria-labelledby="conflict-title">
        <p className="eyebrow">Revision conflict</p>
        <h2 id="conflict-title">This content changed elsewhere</h2>
        <p>
          Your local draft is still here. Choose the server version, or reapply your draft on top of
          the latest revision.
        </p>
        <div className="dialog__actions">
          {onCopyLocal ? (
            <button className="button button--quiet" type="button" onClick={onCopyLocal}>
              Copy local text
            </button>
          ) : null}
          <button className="button button--quiet" type="button" onClick={onAcceptServer}>
            Use server version
          </button>
          <button className="button button--primary" type="button" onClick={onReapplyLocal}>
            Reapply my draft
          </button>
        </div>
      </section>
    </div>
  );
}
